import { render, staticRenderFns } from "./FButtonList.vue?vue&type=template&id=a5983f9a&scoped=true&"
import script from "./FButtonList.vue?vue&type=script&lang=js&"
export * from "./FButtonList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5983f9a",
  null
  
)

export default component.exports